import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { Observable } from 'rxjs';

import { VerifyEmailService } from '../services';

@Injectable({ providedIn: 'root' })
export class VerifyEmailResolver implements Resolve<any> {
  constructor(private readonly verifyEmailService: VerifyEmailService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.verifyEmailService.verifyEmail(route.params.uuid);
  }
}
